import { lazy, Suspense } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import HomePage from 'views/home-page';

const MediaServicePage = lazy(() => import('views/media-service-page'));
const PremiumPlacementPage = lazy(() => import('views/premium-placement-page'));
const MediaPlanningManagementPage = lazy(() => import('views/media-planning-management-page'));
const ChinaMarketSolutionsPage = lazy(() => import('views/china-market-solutions-page'));
const DataDrivenProgrammaticPage = lazy(() => import('views/data-driven-programmatic-page'));
const AiContentCreationPage = lazy(() => import('views/ai-content-creation-page'));
const DataServicePage = lazy(() => import('views/data-service-page'));
const ExternalDataPage = lazy(() => import('views/external-data-page'));
const InsightReportPage = lazy(() => import('views/insight-report-page'));
const EtlProjectPage = lazy(() => import('views/etl-project'));
const PrivacyPolicyPage = lazy(() => import('views/privacy-policy-page'));
const PageNotFound = lazy(() => import('views/page-not-found'));

const withSuspense = (Component) => (
    <Suspense fallback={null}>
        <Component />
    </Suspense>
);

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/',
            element: <HomePage />
        },
        {
            path: '/media-service',
            element: withSuspense(MediaServicePage)
        },
        {
            path: '/premium-placement',
            element: withSuspense(PremiumPlacementPage)
        },
        {
            path: '/campaign-management-service',
            element: withSuspense(MediaPlanningManagementPage)
        },
        {
            path: '/china-media-solutions',
            element: withSuspense(ChinaMarketSolutionsPage)
        },
        {
            path: '/data-driven-programmatic',
            element: withSuspense(DataDrivenProgrammaticPage)
        },
        {
            path: '/ai-creation',
            element: withSuspense(AiContentCreationPage)
        },
        {
            path: '/data-service',
            element: withSuspense(DataServicePage)
        },
        {
            path: '/external-data',
            element: withSuspense(ExternalDataPage)
        },
        {
            path: '/insight-report',
            element: withSuspense(InsightReportPage)
        },
        {
            path: '/etl-project',
            element: withSuspense(EtlProjectPage)
        },
        {
            path: '/privacy-policy',
            element: withSuspense(PrivacyPolicyPage)
        },
        {
            path: '*',
            element: withSuspense(PageNotFound)
        }
    ]
};

export default MainRoutes;
